import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="74" height="34" viewBox="0 0 74 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="74" height="34" rx="4" fill="#7876C1" />
    <rect x="23" width="2" height="34" fill="white" />
    <rect x="49" width="2" height="34" fill="white" />
  </svg>
);

const ColumnsThreeIcon = (props) => <Icon component={svg} {...props} />;

export default ColumnsThreeIcon;
